import { Chip } from 'components/partials/insight-modal/shared/components';
import NavButton from 'containers/user/home/components/shared/navigation-button';
import BlockHeader from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/components/block-header';

import { getFilterDisplayName } from 'constants/report-filters-mapping';

import type { ContextMetadata } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/components/context-data-panel/monitoring-context';

interface ReportContextProps {
  metadata: ContextMetadata | undefined;
  clientId: string | number | undefined;
  sourceId: string | number | undefined;
  showViewReport?: boolean;
  isAdminView?: boolean;
}

const ReportContext = ({
  metadata,
  clientId,
  sourceId,
  showViewReport = true,
  isAdminView = true,
}: ReportContextProps): React.JSX.Element => {
  const reportLink = isAdminView
    ? `/admin/clients/${clientId}/reports/${sourceId}`
    : `/reports/${sourceId}`;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-8 items-start">
        <div>
          <BlockHeader title="Report" />
          <div className="flex flex-wrap gap-2 mb-2">
            <Chip>{metadata?.source || 'Report'}</Chip>
          </div>
          {showViewReport && metadata?.source && (
            <NavButton
              link={reportLink}
              text="View report"
              customClass="text-blue-600 text-sm hover:underline inline-flex items-center gap-1"
            />
          )}
        </div>

        {metadata?.reportFilters && !!metadata.reportFilters.length && (
          <div>
            <h4 className="font-semibold text-gray-700 mb-1">Filters applied</h4>
            <div className="flex flex-wrap gap-2">
              {metadata.reportFilters.map((filter, index) => (
                <Chip key={index}>
                  {typeof filter === 'string'
                    ? filter
                    : `${getFilterDisplayName(filter.column)}: ${
                        Array.isArray(filter.values)
                          ? filter.values.join(', ')
                          : filter.values
                      }`}
                </Chip>
              ))}
            </div>
          </div>
        )}
      </div>

      {metadata?.relatedGoals && !!metadata.relatedGoals.length && (
        <div>
          <BlockHeader title="Related goals" />
          <div className="flex flex-wrap gap-2">
            {metadata.relatedGoals.map((goal, index) => (
              <Chip key={index}>{goal}</Chip>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportContext;
